<template>
  <div>
    <!-- 面包屑导航区 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">{{
        $t('accountmanager.page')
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('accountmanager.system') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('menumanage.menuAdmin') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('menumanage.menuList') }}</el-breadcrumb-item>
    </el-breadcrumb> -->

    <el-card class="box-card">
      <div v-loading="loading">
        <!-- 搜索框 -->
        <el-row class="searchRow">
          <el-col :span="7">
            <!-- clearable为清除键 -->
            <el-input :placeholder="$t('accountmanager.inputtext')" v-model="menuName" clearable @clear="loadMenuList()"
              class="inputSearch">
              <el-button slot="append" icon="el-icon-search" @click="searchMeun()"></el-button>
            </el-input>
          </el-col>
          <el-button type="primary" @click="showAddUserDia()" class="search">{{
            $t('menumanage.addMeun')
            }}</el-button>
        </el-row>

        <el-table class="table" :data="menulist" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column fixed type="index" label="#" width="60"> </el-table-column>

          <el-table-column prop="menuName" :label="$t('menumanage.table.menuName')">
          </el-table-column>

          <el-table-column prop="menuNameVn" :label="$t('menumanage.table.menuNameVn')">
          </el-table-column>

          <el-table-column prop="menuCode" :label="$t('menumanage.table.menuCode')">
          </el-table-column>

          <el-table-column prop="menuGrade" :label="$t('menumanage.table.menuGrade')">
          </el-table-column>

          <el-table-column prop="menuParent" :label="$t('menumanage.table.menuParent')">
          </el-table-column>

          <el-table-column prop="menuParentName" :label="$t('menumanage.table.menuParentName')">
          </el-table-column>
          <!-- 菜单状态 -->
          <el-table-column prop="menuStatus" :label="$t('menumanage.table.menuStatus')">
            <template slot-scope="scope">
              <el-switch class="demo" v-model="scope.row.menuStatus" active-value="0" inactive-value="1"
                inactive-color="#F56C6C" active-color="#00A854" @change="menuStatusChange(scope)">
              </el-switch>
              <!--  :active-text="$t('accountmanager.active')" :inactive-text="$t('accountmanager.inactive')"-->
            </template>
          </el-table-column>

          <el-table-column prop="" :label="$t('accountmanager.operation')">
            <!-- 编辑按钮 -->
            <template slot-scope="scope">
              <el-row>
                <el-popconfirm :ref="`popover-${scope.row.id}-1`" :key="`${scope.row.id}-1`"
                  :title="$t('orders.tip.danger')" @confirm="showEditMenu(scope.row)">
                  <el-button slot="reference" size="mini" plain type="primary" icon="el-icon-edit" circle></el-button>
                </el-popconfirm>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <v-pagination v-model="query" :total="total" @update="getmeun" />

        <!-- 弹出编辑菜单对话框 -->
        <el-dialog :title="$t('menumanage.table.compileMenu')" :visible.sync="editMeunShow" class="customWidth">
          <div v-loading="editloading">
            <el-form :model="eidtMenuFrom" ref="eidtMenuFrom" :rules="rules" prop="menuGrade">
              <el-form-item :label="$t('menumanage.table.menuParent')" :label-width="formlabelWidth">
                <el-select v-model="selectedMenuParent" @change="selectMenuParents">
                  <el-option v-for="(item, index) in menuParents" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                  <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuGrade')" :label-width="formlabelWidth">
                <el-select v-model="selectedMenuLevel">
                  <el-option v-for="(item, index) in menuLevels" disabled :key="index" :label="item.label"
                    :value="item.value">
                  </el-option>
                  <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuUrl')" :label-width="formlabelWidth" prop="menuUrl"
                v-if="eidtMenuFrom.menuGrade == 2">
                <el-input v-model="eidtMenuFrom.menuUrl" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.apiUrl')" :label-width="formlabelWidth" prop="apiUrl"
                v-if="eidtMenuFrom.menuGrade == 3">
                <el-input v-model="eidtMenuFrom.apiUrl" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuCode')" :label-width="formlabelWidth" prop="menuCode">
                <el-input v-model="eidtMenuFrom.menuCode" disabled autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuName')" :label-width="formlabelWidth" prop="menuName">
                <el-input v-model="eidtMenuFrom.menuName" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuNameVn')" :label-width="formlabelWidth" prop="menuNameVn">
                <el-input v-model="eidtMenuFrom.menuNameVn" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuNameEn')" :label-width="formlabelWidth" prop="menuNameEn">
                <el-input v-model="eidtMenuFrom.menuNameEn" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('menumanage.table.sort')" :label-width="formlabelWidth" prop="sort">
                <el-input v-model.trim="eidtMenuFrom.sort" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="canceEidtMenu()">{{ $t('accountmanager.cancel') }}</el-button>
              <el-button type="primary" @click="editMeun()">{{
                $t('accountmanager.confirm')
                }}</el-button>
            </div>
          </div>
        </el-dialog>

        <!-- 弹出添加角色对话框 -->
        <el-dialog :title="$t('menumanage.table.addMenu')" :visible.sync="addMeunShow" class="customWidth">
          <div v-loading="addloaing">
            <el-form :model="addform" ref="addform" :rules="rules">
              <!-- <el-form-item :label="distributedId分布式id" :label-width="formlabelWidth" prop="distributedId">
						<el-input v-model="addform.distributedId" autocomplete="off"></el-input>
					</el-form-item> -->
              <el-form-item :label="$t('menumanage.table.menuParent')" :label-width="formlabelWidth" prop="menuGrade">
                <el-select v-model="selectedMenuParent" @change="selectMenuParent">
                  <el-option v-for="(item, index) in menuParents" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                  <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuGrade')" :label-width="formlabelWidth">
                <el-select v-model="selectedMenuLevel">
                  <el-option v-for="(item, index) in menuLevels" disabled :key="index" :label="item.label"
                    :value="item.value">
                  </el-option>
                  <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuUrl')" :label-width="formlabelWidth" prop="menuUrl"
                v-if="addform.menuGrade == 2 || addform.menuGrade == 1">
                <el-input v-model="addform.menuUrl" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.apiUrl')" :label-width="formlabelWidth" prop="apiUrl"
                v-if="addform.menuGrade == 3">
                <el-input v-model="addform.apiUrl" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuCode')" :label-width="formlabelWidth" prop="menuCode">
                <el-input v-model="addform.menuCode" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuName')" :label-width="formlabelWidth" prop="menuName">
                <el-input v-model="addform.menuName" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item :label="$t('menumanage.table.menuNameVn')" :label-width="formlabelWidth" prop="menuNameVn">
                <el-input v-model="addform.menuNameVn" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('menumanage.table.menuNameEn')" :label-width="formlabelWidth" prop="menuNameEn">
                <el-input v-model="addform.menuNameEn" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('menumanage.table.sort')" :label-width="formlabelWidth" prop="sort">
                <el-input v-model.trim="addform.sort" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelAddMeun()">{{ $t('accountmanager.cancel') }}</el-button>
              <el-button type="primary" @click="addMenu()">{{
                $t('accountmanager.confirm')
                }}</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'menumanage',
    data() {
      return {
        ys: true,
        selectedMenuParent: [{
          value: 1,
          label: this.$t('menumanage.data.LevelOnemenu')
        }],
        selectedMenuLevel: [{
          value: 1,
          label: this.$t('menumanage.data.LevelOnemenu')
        }],
        menuLevels: [{
          value: 1,
          label: this.$t('menumanage.data.LevelOnemenu')
        }],
        options: [{
            value: 1,
            label: this.$t('menumanage.data.LevelOnemenu')
          },
          {
            value: 2,
            label: this.$t('menumanage.data.LevelTwomenu')
          },
          {
            value: 3,
            label: this.$t('menumanage.data.LevelThreebutton')
          }
        ],
        menuParents: [{
          label: this.$t('menumanage.data.LevelOnemenu'),
          value: '0',
          level: 0
        }],
        //验证
        rules: {
          menuGrade: [{
            required: true,
            message: this.$t('menumanage.data.checkmenuGrade'),
            trigger: ['blur', 'change']
          }],
          distributedId: [{
            required: true,
            message: '请输入分布式id', //没用到
            trigger: 'blur'
          }],
          menuCode: [{
            required: true,
            message: this.$t('menumanage.data.checkmenuCode'),
            trigger: 'blur'
          }],
          menuName: [{
            required: true,
            message: this.$t('menumanage.data.checkmenuName'),
            trigger: 'blur'
          }],
          menuNameVn: [{
            required: true,
            message: this.$t('menumanage.data.checkmenuNameVn'),
            trigger: 'blur'
          }],
          menuNameEn: [{
            required: true,
            message: this.$t('menumanage.data.checkmenuNameEn'),
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: this.$t('menumanage.data.sort'),
            trigger: 'blur'
          }],
          menuUrl: [{
            required: true,
            message: this.$t('menumanage.data.menuUrl'),
            trigger: 'blur'
          }],
          apiUrl: [{
            required: true,
            message: this.$t('menumanage.data.apiUrl'),
            trigger: 'blur'
          }]
        },
        loading: false,
        editloading: false,
        addloaing: false,
        query: {
          // current默认第几页
          //size每页条数
          no: 1,
          size: 100
        },
        menuName: '', //搜索
        formlabelWidth: '150px',
        editMeunShow: false, //修改菜单
        addMeunShow: false, //添加菜单
        total: -1,
        addform: {
          menuCode: '',
          menuGrade: '',
          menuName: '',
          menuNameVn: '',
          menuParent: '',
          menuUrl: '',
          sort: ''
        },
        menulist: [],
        eidtMenuFrom: {}
      };
    },
    created() {
      this.getmeun();
    },
    methods: {
      // 修改菜单状态
      async menuStatusChange(scope) {
        this.$confirm(!scope.row.menuStatus ? this.$t("device.changestate") :
          this.$t("device.changestateoff")).then(async () => {
          console.log('号头疼。。。', scope);
          this.loading = true;
          const res = await this.$http.post('/menu/update', scope.row);
          if (res.data.code != 200) return this.$mesasge.error(res.data.msg);
          this.loading = false;
          // console.log('res');
          // console.log(res);
          this.getmeun();
        }).catch(() => {
          scope.row.menuStatus = !scope.row.menuStatus
        });
      },
      //确定修改菜单
      editMeun() {
        this.$refs.eidtMenuFrom.validate(async (valid) => {
          if (!valid) return this.$message.error(this.$t('menumanage.data.changMenuError'));
          this.editMeunShow = false;
          this.loading = true;
          const res = await this.$http.post('/menu/update', {
            id: this.eidtMenuFrom.id,
            apiUrl: this.eidtMenuFrom.apiUrl,
            menuCode: this.eidtMenuFrom.menuCode,
            menuGrade: this.eidtMenuFrom.menuGrade,
            menuName: this.eidtMenuFrom.menuName,
            menuNameVn: this.eidtMenuFrom.menuNameVn,
            menuNameEn: this.eidtMenuFrom.menuNameEn,
            menuParent: this.eidtMenuFrom.menuParent,
            menuUrl: this.eidtMenuFrom.menuUrl,
            menuStatus: this.eidtMenuFrom.menuStatus,
            sort: this.eidtMenuFrom.sort,
          });
          this.loading = false;
          // console.log(this.eidtMenuFrom);
          this.getmeun();
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.$message.success(this.$t('menumanage.data.changMenuSucceed'));
        });
      },

      //点击修改菜单
      async showEditMenu(row) {
        // this, console.log(row);
        // this.selectMenuParents(row.menuParent);
        this.selectedMenuLevel = row.menuGrade;
        this.selectedMenuParent = row.menuParent;
        this.eidtMenuFrom = row;
        this.editMeunShow = true;
        this.editloading = true;
        const res = await this.$http.post('/tree/all');
        this.editloading = false;

        function findChild(data, list) {
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (item.menuGrade >= 3) {
              continue;
            }
            var prefix = '-';
            for (var j = 1; j < item.menuGrade; j++) {
              prefix = prefix + '-';
            }
            item.menuName = prefix + item.menuName;
            //向数组中添加menuName，menuCode编码，menuGrade数字
            list.push({
              label: item.menuName,
              value: item.menuCode,
              level: item.menuGrade,
              menuParent: item.menuParent
            });
            //如果有子把子中的menuName，menuCode，menuGrade继续追加到数组后面
            if (item.childrenMenus.length > 0) {
              findChild(item.childrenMenus, list);
            }
          }
        }
        //给数组设置默认值
        this.menuParents = [{
          label: this.$t('menumanage.data.LevelOnemenu'),
          value: '0',
          level: 0
        }];
        findChild(res.data.data, this.menuParents);
        //this.addMeunShow = true;
      },
      // 取消修改
      canceEidtMenu() {
        this.editMeunShow = false;
        this.$refs.eidtMenuFrom.resetFields();
      },
      //取消添加
      cancelAddMeun() {
        this.addMeunShow = false;
        this.$refs.addform.resetFields();
      },
      //搜索
      searchMeun() {
        this.getmeun();
      },
      //搜索清除
      loadMenuList() {
        this.getmeun();
      },
      //确定添加菜单请求
      addMenu() {
        this.$refs.addform.validate(async (valid) => {
          if (!valid) return this.$message.error(this.$t('menumanage.data.addMenuError'));
          // if(this.addMeunShow.menuParent)
          this.loading = true;
          const res = await this.$http.post('/menu/add', this.addform);
          this.loading = false;
          if (res.data.code == 200) {
            this.$message.success(this.$t('menumanage.data.addMenuSucceed'));
            this.addMeunShow = false;
            this.getmeun();
          } else {
            this.$message.error(res.data.msg);
          }
          // console.log(this.addform);
          this.addform = {};
        });
      },
      //修改角色下拉框状态发生改变时
      selectMenuParents: function (val) {
        // console.log(val);
        var idx = 0;
        for (var i = 0; i < this.menuParents.length; i++) {
          if (val == this.menuParents[i].value) {
            idx = this.menuParents[i].level;
            this.eidtMenuFrom.menuParent = val;
            break;
          }
        }
        this.selectedMenuLevel = parseInt(idx) + 1;
        this.eidtMenuFrom.menuGrade = this.selectedMenuLevel;
        //父级默认是0就填出一级菜单
        if (val == 0) {
          this.menuLevels = [this.options[0]];
          this.eidtMenuFrom.menuGrade = this.menuLevels[0].value;
        } else {
          this.menuLevels = [];
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].value == parseInt(idx) + 1) {
              this.menuLevels.push(this.options[i]);
            }
          }
        }
      },
      //添加角色下拉框状态发生改变时
      selectMenuParent: function (val) {
        var idx = 0;
        for (var i = 0; i < this.menuParents.length; i++) {
          if (val == this.menuParents[i].value) {
            idx = this.menuParents[i].level;
            this.addform.menuParent = val;
            console.log('menuParent自己');
            console.log(this.addform.menuParent);
            if (this.addform.menuParent == undefined) {
              this.addform.menuParent = '';
            }
            break;
          }
        }
        this.selectedMenuLevel = parseInt(idx) + 1;
        this.addform.menuGrade = this.selectedMenuLevel;
        console.log('menuGrade儿子');
        console.log(this.addform.menuGrade);
        //父级默认是0就填出一级菜单
        if (val == 0) {
          this.menuLevels = [this.options[0]];
          this.addform.menuGrade = this.menuLevels[0].value;
          // console.log('menuGrade儿子');
          // console.log(this.addform.menuGrade);
        } else {
          this.menuLevels = [];
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].value == parseInt(idx) + 1) {
              this.menuLevels.push(this.options[i]);
              //this.addform.menuGrade = this.menuLevels[0].value;
            }
          }
        }
      },
      //点击添加菜单
      /**
       * 一级菜单apiUrl，menuUrl可以为空
       * 二级菜单menuUrl不可以为空aipUrl绑定当前页面主表格的接口api
       * 三级菜单menuUrl可以为空api不可为空绑定具体的api
       *
       * 选一二级的时候   让用户填写  menuUrl，选三级的时候填写apiurl
       */
      async showAddUserDia() {
        this.addMeunShow = true;
        this.addloaing = true;
        const res = await this.$http.post('/tree/all');
        this.addloaing = false;

        function findChild(data, list) {
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (item.menuGrade >= 3) {
              continue;
            }
            var prefix = '-';
            for (var j = 1; j < item.menuGrade; j++) {
              prefix = prefix + '-';
            }
            item.menuName = prefix + item.menuName;
            //向数组中添加menuName，menuCode编码，menuGrade数字
            list.push({
              label: item.menuName,
              value: item.menuCode,
              level: item.menuGrade,
              menuParent: item.menuParent
            });
            //如果有子把子中的menuName，menuCode，menuGrade继续追加到数组后面
            if (item.childrenMenus.length > 0) {
              findChild(item.childrenMenus, list);
            }
          }
        }
        //给数组设置默认值
        this.menuParents = [{
          label: this.$t('menumanage.data.LevelOnemenu'),
          value: '0',
          level: 0
        }];
        findChild(res.data.data, this.menuParents);
        //this.addMeunShow = true;
      },

      async getmeun() {
        this.loading = true;
        const res = await this.$http.post(
          '/menu/list?', {
            query: {
              menuName: this.menuName,
            },
            no: this.query.current,
            size: this.query.size
          }
        );
        this.loading = false;
        this.menulist = res.data.data.list;
        // console.log(this.menulist);
        this.total = res.data.data.rows;
      }
    }
  };

</script>

<style scoped>
  .box-card,
  .table,
  .pag {
    margin-top: 20px;
  }

  /deep/.demo {
    .el-switch__core {
      width: 70px !important;
    }

    .el-switch__label {
      display: flex;
      width: 70px !important;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menumanage/index.vue